import GradeLessonPage from '../components/GradeLessonPage';
import { grade3Topics } from './data';

export default function Grade3Page() {
  return (
    <GradeLessonPage
      grade="3"
      gradeLabel="Grade 3"
      gradeColor="amber"
      topics={grade3Topics}
      prevGrade={{ label: 'Grade 2', path: '/grade/2' }}
      nextGrade={{ label: 'Grade 4', path: '/grade/4' }}
    />
  );
}
